/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiCursorAWindowIcon24Solid = forwardRef('UiCursorAWindowIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M5.75 2A3.75 3.75 0 0 0 2 5.75v9.5A3.75 3.75 0 0 0 5.75 19h4.242L10 11.239c.004-2.884 3.298-4.527 5.604-2.794L19 11V5.75A3.75 3.75 0 0 0 15.25 2h-9.5Z" }),
        React.createElement("path", { d: "M12 11.241c.002-1.236 1.414-1.94 2.402-1.197l7.73 5.812c1.345 1.01.629 3.15-1.053 3.149L17.493 19a.25.25 0 0 0-.2.1l-2.155 2.866c-1.01 1.344-3.15.628-3.149-1.054L12 11.241Z" })));
});
